<template>
    <div class="pl-lg-4">

        <div class="col-lg-12" v-if="isLoadingBlade">
            <div class="d-flex justify-content-center">
                <img :src="loadingBladeUrl" />
            </div>
        </div>
        
        <div class="row" v-if="! isLoadingBlade">

            <div class="col-sm-12 text-center borderLine">
                <br>
                <h4 class="text-uppercase height-50">
                    Please follow the link below to make payment exclusively for the verification of your credentials for this application. <br>
                    The outcome of the verification will be sent directly to MDCN
                </h4>
                <br><br>

                <a
                    href="https://mdcn.dataflowgroup.com/en/onboarding"
                    class="btn btn-lg btn-success"
                    target="_blank"
                >
                    <i class="fa fa-share-square"></i> Click Here
                </a>
                <br>
                <br>
                <hr>
                <h4 class="text-uppercase text-danger height-50" v-if="isRenewal">
                    Kindly skip this verification step if you are applying for renewal...
                </h4>
                <h4 class="text-uppercase text-danger height-50" v-if="! isRenewal">
                    Upon successful verification, you may proceed with your application below...
                </h4>
            </div>


        </div>

        <base-alert :type="errorType" dismissible v-if='showErrorStatus'>
            <span class="alert-inner--icon"><i class="ni ni-like-2"></i></span>
            <span class="alert-inner--text">
                {{errorMsg}}
            </span>
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </base-alert>

        <hr class="my-4"/>

        <div v-if="! isLoadingBlade">
            <base-button 
                type="danger" 
                @click="showPreviousPage()"
            >
                <i class="fa fa-arrow-left"></i> 
                Previous
            </base-button>

            <div class="right">
                <base-button 
                    type="success" 
                    @click="updateVerifyCountries()"
                >
                    {{ isloading ? 'Please Wait...' : exactButtonText }}                    
                    <i class="fa fa-arrow-right"></i> 
                </base-button>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: 'VerificationLink',
        props: ['displayAddRecords', 'displayReg', 'isRenewal'],
        data() {
            return {
                record: {
                    med_school_country: null,
                    aq_country: null
                },
                showErrorStatus: false,
                errorType: null,
                errorMsg: null,
                isloading: false,
                isLoadingBlade: false
            }
        },
        computed: {
            ...mapGetters(['loadingBladeUrl']),
            exactButtonText() {// exact text for proceed button
                return (this.isRenewal ? 'Proceed' : 'Skip');
            }
        },
        methods: {
            ...mapActions(['updateTempAssessment']),
            showPreviousPage() {
                return this.displayAddRecords(true);
            },
            showNextPage() {
                return this.displayReg(true);
            },
            updateVerifyCountries() {
                this.isloading = true;
                this.updateTempAssessment(this.record).then((res) => {
                    this.showNextPage(); // refresh profile
                    this.isloading = false;
                });
            },
        }
    }
</script>

<style scoped>
.right {
    float: right;
}
</style>